export const statisticsKeys = {
  all: ["verification-statistics"] as const,
  numbers: (fromDate?: string, toDate?: string) =>
    [...statisticsKeys.all, "numbers", fromDate, toDate] as const,
  assignment: (fromDate?: string, toDate?: string) =>
    [...statisticsKeys.all, "assignment", fromDate, toDate] as const,
  quality: (fromDate?: string, toDate?: string) =>
    [...statisticsKeys.all, "quality", fromDate, toDate] as const,
};
